import React, { Fragment, useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Stage, Layer, Rect, Star, Text, Transformer } from 'react-konva';
import ReactDOM from "react-dom";
import TmpltSection from './TmpltSection';
import { useAppDispatch, useAppSelector } from '../../../../../../../redux/hook';
import { setPrevTemplate, setTemplate } from '../../../../../../../redux/slices/template/templateSlice';
import { Section, Template } from '../../../../../../../redux/slices/template/templateModels';
import { getCorrespondHeight, getCorrespondWidth, getRealHeight, getRealWidth, getSectColorHexCodes } from '../../../../../../../redux/slices/editor/editorModels';
import { setTemplateSettings } from '../../../../../../../redux/slices/editor/editorSlice';

// const w = 300;
// const h = 500;
// function generateSections() {
//   return [...Array(10)].map((_, i) => ({
//     id: i.toString(),
//     x: Math.random() * w,
//     y: Math.random() * h,
//     rotation: Math.random() * 180,
//     isDragging: false,
//   }));
// }

// const INITIAL_STATE = generateSections();


// type Section = {  //like position in template
//   id: string,
//   x: number,
//   y: number,
//   width: number,
//   height: number,
//   key?: number | string,
//   fill?: string,
//   stroke?: string,
//   type: string,
// }

const initialSections: Section[] = [];
// ----------------------------

const TemplateEditorPanel = ({editorWidth=960, editorHeight=540, clsName="bg-gray-500"}) => {
  const dispatch = useAppDispatch()  
  //-----------------------------------------
  const stageRef       = useRef<any>(null);
  const transformerRef = useRef<any>(null);
  
  // const currPersistContent = useAppSelector(state => state.persistor._content.currContent)
  const currPersistTemplate = useAppSelector(state => state.persistor._template.currTemplate)
  // const prevPersistTemplate = useAppSelector(state => state.persistor._template.prevTemplate)

  const newTmpltSetting = useAppSelector(state => state.editor.templateToolsSettings)
  // console.log("newTmpltSetting in Panel: ", newTmpltSetting)

  // console.log("=====")
  // console.log("currPersistContent:", currPersistContent)
  // console.log("currPersistTemplate:", currPersistTemplate)
  // console.log("prevPersistTemplate:", prevPersistTemplate)

  const currEditorW = useAppSelector(state => state.editor.currEditorWidth)
  const currEditorH = useAppSelector(state => state.editor.currEditorHeight)
  const currEditorZoom = useAppSelector(state => state.editor.zoomPercentage)
  // console.log("currEditorW:", currEditorW)
  // console.log("currEditorH:", currEditorH)
  // console.log("currEditorZoom:", currEditorZoom)
  // -----------------------

  // console.log("editorWidth, editorHeight:", editorWidth, ", ", editorHeight)
  // -----------------------

  // const [sections, setSections] = useState<Section[]>([{...initialSections[0]}]);
  const [sections, setSections] = useState<Section[]>([]);
  // console.log("sections: ",sections)  
  const [newSection, setNewSection] = useState<Section[]>([]);  
  // console.log("newSection: ",newSection)
  // const [sectionsToDraw, setSectionsToDraw] = useState<Section[]>([...sections, ...newSection]);
  const [sectionsToDraw, setSectionsToDraw] = useState<Section[]>([]);
  // console.log("outside ===== sectionsToDraw: ",sectionsToDraw)
  const [prevSectionsToDraw, setPrevSectionsToDraw] = useState<Section[]>([]);
  // console.log("outside ===== prevSectionsToDraw: ",prevSectionsToDraw)

  const [selectedId, setSelectedId] = useState<string | null>(null);
  console.log("selectedId: ",selectedId)

  // ------------------------------  

  
  // ------------------------
  // const checkDeselect = (event: any) => {
  //   // deselect when clicked on empty area
  //   const clickedOnEmpty = event.target === event.target.getStage();
  //   if (clickedOnEmpty) {
  //     setSelectedId(null);
  //   }
  // };

  // ------------------------
  // Selecting or click on object
  // -------------------------
  const handleMouseDown = (event: any) => {
    // console.log("handleMouseDown")
    // deselect when clicked on empty area
    const clickedOnEmpty = event.target === event.target.getStage();
    if (clickedOnEmpty) {
      setSelectedId(null);

      // Draw a new section
      if (newSection.length === 0) {
        const { x, y } = event.target.getStage().getPointerPosition();
        setNewSection([{  x, 
                          y, 
                          width: 0,
                          height: 0,
                          key: "0",
                          // id: Math.random().toString(9).slice(0,5).replace('0.', '').toUpperCase(),
                          id: (sectionsToDraw.length +1)+"",
                          fill: '#9C258Faa',
                          stroke:"#A1A5B7",
                          type: newTmpltSetting ? newTmpltSetting.type : "video",
                        }]);
      }      
    }    
  }

  // ------------------------
  // Moving or Resizing object
  // -------------------------
  const handleMouseUp = (event: any) => {
    // console.log("handleMouseUp")

    if (newSection.length === 1) {
      const sx = newSection[0].x;
      const sy = newSection[0].y;
      const { x, y } = event.target.getStage().getPointerPosition();

      if (x-sx >0 && y-sy>0){ //avoid a new section where (w=0 or h=0)
        const sectionToAdd : Section = {
                                          x     : sx,
                                          y     : sy,
                                          width : x - sx,
                                          height: y - sy,
                                          key   : sections.length + 1,
                                          // id    : Math.random().toString(9).slice(0,5).replace('0.', '').toUpperCase(),
                                          id    : (sectionsToDraw.length +1)+"",
                                          fill  : '#b5b5c3bb',
                                          stroke: "#A1A5B7",
                                          type  : newTmpltSetting ? newTmpltSetting.type : "video",
                                        };
        sections.push(sectionToAdd);
      }

      // console.log("sectionToAdd:", sectionToAdd)

      setNewSection([]);
      setSections(sections);
    }
  };

  // --------------------------
  // Create new object
  // -------------------------
  const handleMouseMove = (event: any) => {
    // console.log("handleMouseMove")

    if (newSection.length === 1) {
      const sx = newSection[0].x;
      const sy = newSection[0].y;
      const { x, y } = event.target.getStage().getPointerPosition();
      setNewSection([{
                      x     : sx,
                      y     : sy,
                      width : x - sx,
                      height: y - sy,
                      key   : "0",
                      // id    : Math.random().toString(9).slice(0,5).replace('0.', '').toUpperCase(),
                      id    : (sectionsToDraw.length +1)+"" ,
                      fill  : '#b5b5c388',
                      stroke: "#A1A5B7",
                      type  : newTmpltSetting ? newTmpltSetting.type : "video",
                    }]);

      console.log("newSection:", newSection)

    }
  };



  // ----------------------------------------
  const getListSections = (currTmplt: Template) => {
    let listSections : Section[] = [];
    //---------------------------------
    if (currTmplt.positions){
      listSections = currTmplt.positions?.map((pos, ind)=> {
        return  {
                  x     : getCorrespondWidth( pos.x, pos.y, currEditorW, currEditorH, currEditorZoom),
                  y     : getCorrespondHeight(pos.x, pos.y, currEditorW, currEditorH, currEditorZoom),
                  width : getCorrespondWidth( pos.w, pos.h, currEditorW, currEditorH, currEditorZoom),
                  height: getCorrespondHeight(pos.w, pos.h, currEditorW, currEditorH, currEditorZoom),
                  
                  key   : ""+ind,
                  // id    : Math.random().toString(9).slice(0,5).replace('0.', '').toUpperCase(),
                  id    : pos.alias,
                  fill  : getSectColorHexCodes(pos.element_type),
                  stroke: "#A1A5B7",
                  type  : pos.element_type,
                }
      })
    } 
    return listSections
  }



  // =======================================
  useEffect(() => {
    setPrevSectionsToDraw([...sectionsToDraw]);
    setSectionsToDraw([...sections, ...newSection]);
    // console.log("new sectionsToDraw:", sectionsToDraw)
  }, [sections, newSection])

  // --- first time loading
  // ------------------------
  useEffect(() => {
    setSections(getListSections(currPersistTemplate));        
  }, []) 


  useEffect(() => {
    if (selectedId){
      dispatch(setTemplateSettings({...newTmpltSetting, selectedSect: selectedId}))
    }else{
      dispatch(setTemplateSettings({...newTmpltSetting, selectedSect: ""}))
    }      
  }, [selectedId]) 

  useEffect(() => {
    setSelectedId(newTmpltSetting.selectedSect)
  }, [newTmpltSetting])
 

  // --- When template is updated
  // -----------------------------
  useEffect(() => {    
    setPrevSectionsToDraw(sectionsToDraw);
    setSectionsToDraw(getListSections(currPersistTemplate));
  }, [currPersistTemplate, currEditorZoom])


  // --- When drawing is changing
  // ----------------------------------
  useEffect(() => {

    if (JSON.stringify(sectionsToDraw) !== JSON.stringify(prevSectionsToDraw)){ //to avoid loop/recursive btw currPersistTemplat & sectionsToDraw
      setPrevSectionsToDraw(sectionsToDraw);  //update previous drawings

      let containUndefined = false;
      sectionsToDraw.forEach(sect => {
        if (sect === undefined){
          console.log("undefined sectionsToDraw:", sectionsToDraw)
          containUndefined = true;
        }
      })
      
      if (!containUndefined){
        const newTmplt:Template = { ...currPersistTemplate,
                                    positions: (!sectionsToDraw) ? [] : sectionsToDraw.map((sect, ind) => {
                                      // console.log("sect- in here:", sect)
                                      // if (sect){
                                        return {
                                          position_id: "",
                                          template_id: "",
                                          x: getRealWidth (sect.x, sect.y, currEditorW, currEditorH, currEditorZoom),
                                          y: getRealHeight(sect.x, sect.y, currEditorW, currEditorH, currEditorZoom),
                                          w: getRealWidth (sect.width, sect.height, currEditorW, currEditorH, currEditorZoom),
                                          h: getRealHeight(sect.width, sect.height, currEditorW, currEditorH, currEditorZoom),
                                          layer: (ind+1),
                                          element_type: sect.type,
                                          alias: sect.id,
                                          // alias: `custom_${ind+1}`,
                                          default_source_id: '0',
                                          selectable: 1
                                        }
                                      // }else{
                                      //   return {
                                      //     position_id: "",
                                      //     template_id: "",
                                      //     x: getRealWidth (0, 0, currEditorW, currEditorH, currEditorZoom),
                                      //     y: getRealHeight(0, 0, currEditorW, currEditorH, currEditorZoom),
                                      //     w: getRealWidth (0, 0, currEditorW, currEditorH, currEditorZoom),
                                      //     h: getRealHeight(0, 0, currEditorW, currEditorH, currEditorZoom),
                                      //     layer: (ind+1),
                                      //     element_type: "video",
                                      //     alias: "",
                                      //     default_source_id: '0',
                                      //     selectable: 1
                                      //   }
                                      // }
                                    })
        }
        // console.log("newTmplt in SectionsToDraw Change : ", newTmplt)

        dispatch(setPrevTemplate(currPersistTemplate))  //problem of recursive here
        dispatch(setTemplate(newTmplt))  //problem of recursive here
      }
    }
  }, [sectionsToDraw])


  
    
  // ------------------------------
  return (
    <Stage      
      ref={stageRef}
      onClick={(e) =>
          e.target === stageRef.current && transformerRef.current.nodes([])
      }
      width ={editorWidth}
      height={editorHeight}  
      className={`${clsName}`}
      
      // onTouchStart={checkDeselect} 
      // onMouseDown={checkDeselect}
      onTouchStart={handleMouseDown} 
      onMouseDown ={handleMouseDown}

      onMouseUp   ={handleMouseUp}
      onMouseMove ={handleMouseMove}
    >
      <Layer>        
        {sectionsToDraw.map((_sect: Section, i) => {
          // console.log(i, "_sect:", _sect)
          // ------------------------------
          if (_sect){
            return (
              // <Layer>
              <TmpltSection
                key={`keySect_${i}`}
                sectionProps={_sect}
                isSelected = {_sect.id === selectedId}
                onSelect={() => { setSelectedId(_sect.id); }}
                onChange={(newAttrs: any) => {
                  const _sects = sections.slice();
                  _sects[i] = newAttrs;
                  setSections(_sects);
                }}
              />
              // </Layer>
            );
          }else{
            return ;
          }
        })}

        <Transformer ref={transformerRef} />
      </Layer>
    </Stage>
    )
  }

export default TemplateEditorPanel;